"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = exports.default = void 0;

var _createTheme = _interopRequireDefault(require("@mui/material/styles/createTheme.js"));

var _system = require("@mui/system");

var _react = _interopRequireDefault(require("react"));

var _Colors = _interopRequireDefault(require("./Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = (0, _createTheme.default)({
  palette: {
    primary: {
      main: _Colors.default.orange
    },
    secondary: {
      main: _Colors.default.textElementGrey
    },
    error: {
      main: _Colors.default.warningRed
    },
    warning: {
      main: _Colors.default.warning
    },
    info: {
      main: _Colors.default.optimizerBlue
    },
    success: {
      main: _Colors.default.acceptGreen
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    }
  }
});
exports.defaultTheme = defaultTheme;

var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_system.StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/_react.default.createElement(_system.ThemeProvider, {
    theme: theme
  }, children));
};

var _default = ThemeProvider;
exports.default = _default;